import Text from "@/components/Text";
import { AuthorizationExpiry } from "../ccm-consent-types";
import { getExpiryNote } from "../ccm-consent-utils";

export interface ConsentExpiryNoteProps {
  expiry: AuthorizationExpiry | "";
  expiryDate: string | null;
  defaultMonths: number;
}

const ConsentExpiryNote = ({
  expiry,
  expiryDate,
  defaultMonths,
}: ConsentExpiryNoteProps) => {
  const note = getExpiryNote(expiry, expiryDate, defaultMonths);
  return note ? (
    <Text fontStyle="italic" textAlign="center">
      {note.text}
      {note.date && <strong>{note.date}</strong>}
      {note.after}
    </Text>
  ) : null;
};

export default ConsentExpiryNote;
